<template>
  <div class="agency">
    <div class="top">
      <div class="map_page" :class="{ isactive: !isListShow }">
        <img class="icondt" :src="require(`@/assets/images/classify.png`)" alt="" @click="toggleHandle(true)" />
      </div>
      <div class="list_page" :class="{ isactive: isListShow }">
        <img class="iconjg" :src="require(`@/assets/images/location1.png`)" alt="" @click="toggleHandle(false)" />
      </div>
    </div>
    <div class="list" v-show="isListShow">
      <div
        class="list_item"
        v-for="(item, index) in 10"
        :key="item"
        @click="agencyList(item)"
      >
        <span>{{ mapList[index].name }}</span>
        <img :src="require(`@/assets/images/${item}.png`)" alt="" />
      </div>
    </div>
    <div class="careMap" v-show="!isListShow">
      <div id="container" class="container"></div>
      <div class="orgInfoBox">
        <div
          class="leftOrg"
          v-for="item of mapList"
          :key="item.name"
          :style="{
            justifyContent: item.right ? 'flex-end' : 'flex-start'
          }"
        >
          <div :class="['orgItem', item.class]" @click="goToMap(item)">
            <img :src="require(`@/assets/images/${item.name}.png`)" />
            <span>{{ item.name }}</span>
            <span class="number">{{ item.num }}</span>
            <span>家</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AMap from "AMap";
import { countOrgByAreaCode } from "@/api/agency";
import { areaCode } from "@/common/constants.js";
import title from "@/common/constants.js";

export default {
  name: "Agency",
  components: {},
  data() {
    return {
      centerCo: [121.47254, 31.232777],
      map: "",
      isListShow: true,
      mapList: [
        {
          name: "养老院",
          class: "yly",
          orgType: "1010",
          num:1
        },
        {
          name: "长者照护之家",
          class: "zzzh",
          orgType: "1011",
          right: true // 右对齐
        },
        {
          name: "综合为老服务中心",
          class: "zhwl",
          orgType: "2011"
        },
        {
          name: "家门口养老服务站",
          class: "mlzx",
          orgType: "2022",
          num: 2,
          right: true // 右对齐
        },
        {
          name: "适老化智慧养老体验中心",
          class: "slhzh",
          orgType: "2026",
          num: 1
        },
        {
          name: "老年日托所",
          class: "lnrts",
          orgType: "2010",
          right: true // 右对齐
        },
        {
          name: "助餐点",
          class: "zcd",
          orgType: "2014, 2015"
        },
        {
          name: "社区为老服务站",
          class: "sqwl",
          orgType: "2024",
          right: true // 右对齐
        },
        {
          name: "长者运动健康之家",
          class: "zzyd",
          orgType: "2027",
          num: 1
        },
        {
          name: "老年活动室",
          class: "lnhd",
          orgType: "2013",
          right: true // 右对齐
        }
      ]
    };
  },
  methods: {
    toggleHandle(status) {
      this.isListShow = status;
      if (!status && !this.map) {
        this.initMap();
      }
    },
    agencyList(item) {
      // title.agencyList = this.mapList[item - 1].name;

      this.$router.push({
        name: "agencyList",
        query: {
          orgTypes: this.mapList[item - 1].orgType,
          title: this.mapList[item - 1].name
        }
      });
    },
    // 生成地图背景
    initMap() {
      return new Promise(() => {
        var map = new AMap.Map("container", {
          center: this.centerCo,
          resizeEnable: true,
          zoom: 16,
          scrollWheel: false,
          zoomEnable: false,
          dragEnable: false
        });
        this.map = map;
      });
    },

    // 获取机构家数数据
    getMapNewList() {
      return new Promise(resolve => {
        countOrgByAreaCode({ areaCode: areaCode }).then(res => {
          if (res.code === 0) {
            this.mapList.forEach(item => {
              res.data.forEach(it => {
                if (it.org_type == item.orgType && !item.num) {
                  item.num = it["count(1)"];
                }
              });
            });
          }
          resolve();
        });
      });
    },
    // 跳转到地图机构定位
    goToMap(item) {
      title.map = item.name;
      this.$router.push({
        path: "/map",
        query: {
          type: item.name
        }
      });
    }
  },
  created() {
    this.getMapNewList();
  }
};
</script>

<style lang="scss" scoped>
.agency {
  position: relative;
  .top {
    position: absolute;
    z-index: 999999;
    top: 15px;
    right: 0;
    display: flex;
    background-color: rgba($color: #000000, $alpha: 0);
    .list_page,
    .map_page {
      margin-left: 15px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      // background-color: #fff;
      // box-shadow: 0 2px 10px #999;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width:58px;
        height:58px;
      }
    }
    .map_page.isactive {
      background-color: #7dceff;
      span {
        color: #fff;
      }
    }
    .list_page.isactive {
      // background-color: #ffd63c;
      span {
        color: #fff;
      }
    }
  }
  .list {
    padding-top: 60px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .list_item {
      position: relative;
      border-radius: 15px;
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 163px;
      height: 104px;
      // background-color: #fff6de;
      span {
        position: absolute;
        top: 75px;
        width: 100%;
        font-size: 14px;
        font-weight: 700;
        text-align: center;
      }
      img {
        width: 125%;
      }
      .logo {
        img {
          width: 38px;
          height: 36px;
          margin-bottom: 12px;
        }
      }
      .name {
        opacity: 0.9;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        text-align: left;
        color: #000000;
      }
    }
  }
  .careMap {
    .container {
      // position: absolute;
      // left: -20px;
      height: calc(100vh - 50px);
      width: 100vw;
    }
    .orgInfoBox {
      width: 100vw;
      height: 90vh;
      // left: -20px;
      position: absolute;
      top: 0;
      .leftOrg {
        font-size: 14px;
        display: flex;
        align-items: center;
        height: 10%;
        .orgItem {
          border-radius: 4px;
          color: white;
          box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.23);
          display: inline-flex;
          justify-content: flex-start;
          align-items: center;
          background-color: thistle;
          height: 30px;
          padding: 5px;
          margin: 0 20px;
          img {
            width: 20px;
            height: 20px;
          }
          span {
            margin-left: 8px;
          }
          .number {
            color: #145e8a;
            font-size: 18px;
          }
        }
        .yly {
          background-color: #ffbc2d;
        }
        .zzzh {
          background-color: #7dceff;
        }
        .zhwl {
          background-color: #5ed9c3;
        }
        .mlzx {
          background-color: #ff8189;
        }
        .slhzh {
          background-color: #ffbc2d;
        }
        .lnrts {
          background-color: #7dceff;
        }
        .zcd {
          background-color: #5ed9c3;
        }
        .sqwl {
          background-color: #ff8189;
        }
        .zzyd {
          background-color: #ffbc2d;
        }
        .lnhd {
          background-color: #7dceff;
        }
      }
    }
  }
}
</style>
